import React from 'react';
import PropTypes from 'prop-types';

const CheckboxButton = ({ children, name, label, onChange, value, checked, disabled }) => {
  const uniqueIdentifier = `${value}-${name}`;

  // If the component has children, render them instead of the label
  let buttonText;
  if (children) {
    buttonText = children;
  } else {
    buttonText = label;
  }

  return (
    <div className="checkbox-btn">
      <input
        type="checkbox"
        id={uniqueIdentifier}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        className="checkbox-input-faux"
      />
      <label htmlFor={uniqueIdentifier} className="btn btn--tertiary checkbox-btn__label">{buttonText}</label>
    </div>
  );
};

CheckboxButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default CheckboxButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/CheckboxButton.js